import React from 'react';
import SystemSettingsPage from './components/system/SystemSettingsPage';

export default function SystemSettings() {
    return <SystemSettingsPage/>;
}
